import { UnknownError } from '@cian/peperrors';

import { assertions } from './assertions';
import { fetchSendFirstMessageToAgent } from '../../../repositories/chats/v3/send-first-message-to-agent';
import { showAlert } from '../../../slices/alertSlice';
import { TThunkAction } from '../../../types/redux/thunk';
import { ETelemetryEvents } from '../../../types/telemetry';
import { setFirstMessageFailed, setFirstMessagePending } from '../actions';
import { DEFAULT_ERROR_MESSAGE } from '../constants';
import { mappers } from '../mappers';
import { TFirstMessageResponse } from '../types';
import { getDomainBySource, getTelemetryBySource } from '../utils';

interface ISendFirstMessageAgentProps {
  /** Токен капчи(для проверки валидности, только desktop) **/
  captchaToken?: string;
  /** Идентификатор агента **/
  agentId: number;
  /** Текст сообщения **/
  text: string;
}

const SOURCE = 'agent';

/**
 * @description
 * Отправка первого сообщения агенту
 */
export const sendFirstMessageAgent =
  ({ agentId, text, captchaToken }: ISendFirstMessageAgentProps): TThunkAction<Promise<void>> =>
  async (dispatch, _, { httpApi, telemetry, logger }) => {
    dispatch(setFirstMessagePending());

    const agentTelemetry = getTelemetryBySource(telemetry, SOURCE);

    const domain = getDomainBySource(SOURCE);

    agentTelemetry.increment(ETelemetryEvents.ChatFirstMessageSendInit);

    const startTime = Date.now();

    try {
      const response = (await fetchSendFirstMessageToAgent({
        httpApi,
        parameters: {
          userId: agentId,
          text,
          captchaToken,
        },
        mappers,
      })) as TFirstMessageResponse;

      assertions.forEach(assertion => {
        dispatch(
          assertion(response, {
            domain,
            telemetry: agentTelemetry,
            text,
            startTime,
          }),
        );
      });
    } catch (error) {
      agentTelemetry.increment(ETelemetryEvents.ChatFirstMessageSendUnknownError);

      const unknownError = new UnknownError({
        message: DEFAULT_ERROR_MESSAGE,
        domain,
        details: error,
      });

      logger.error(unknownError);

      dispatch(setFirstMessageFailed());
      dispatch(showAlert({}));
    }
  };
